import moduleCollapsible from '../../modules/module--collapsible';

export default function() {
    moduleCollapsible.add({
        block: '.menu-topbar__dropdown',
        elToggle: '.menu-topbar__dropdown-toggle',
        elContent: '.menu-topbar__dropdown-content',
        closeOutside: true,
        closeAny: true,
        closeOthers: false,
        debug: false,
        callbackBuilt() {
            $('#menu-topbar__label').text($('.menu-topbar__link.--active').text());
        }
    });
}
